export default "__VITE_ASSET__BZLsh0cz__"